import React, { memo, useMemo } from 'react';
import { TextWrapper } from '../chess-game.styled';
import { useQuery } from '@tanstack/react-query';

type Props = {
  time: number;
  active: boolean;
  countdownID: number;
  totalTime: number;
  handleTotalTime: (time: number) => void;
};

const CountDown = memo((props: Props) => {
  const { countdownID, totalTime, active, handleTotalTime } = props;
  useQuery({
    queryKey: [`countdownInterval${countdownID || ''}`, countdownID],
    queryFn: () => {
      if (!active || totalTime <= 0) {
        return -1;
      }

      handleTotalTime(totalTime - 1);
      return -1;
    },
    retry: false,
    refetchInterval: 1000,
    enabled: !!active && totalTime > 0
  });

  console.log('totalTime', totalTime);

  const timeParse = useMemo(() => {
    const _totalTime = totalTime * 1000;
    const minutes: number = Math.floor((_totalTime % (1000 * 60 * 60)) / (1000 * 60));
    const seconds: number = Math.floor((_totalTime % (1000 * 60)) / 1000);
    return {
      minutes,
      seconds
    };
  }, [totalTime]);

  return (
    <TextWrapper
      initial={{ scale: 0, opacity: 0 }} // Start small and invisible
      animate={{ scale: 1, opacity: 1 }} // Grow to full size and visible
      exit={{ scale: 0, opacity: 0 }} // Shrink and fade out when changing
      transition={{ duration: 0.5 }} // Adjust timing for smooth animation
      key={totalTime} // Important for Framer Motion to detect changes
      className={`${props?.active ? 'text-[#E8DAC4]' : 'text-[#4F4D49]'}`}
    >
      {timeParse?.minutes} : {timeParse?.seconds}
    </TextWrapper>
  );
});

export default CountDown;
